<app-main-resource-catalog [scope]="AppScope.E_COURSE"></app-main-resource-catalog>
